<div class="legal-container">
  <h1>Política de Privacidad</h1>
  <p>En Innovadoc IA, la privacidad de nuestros usuarios es una prioridad. Esta página describe cómo recopilamos, usamos y protegemos tu información personal.</p>
  <h2>Recopilación de datos</h2>
  <ul>
    <li>Solo recopilamos los datos necesarios para el funcionamiento del servicio.</li>
    <li>No vendemos ni compartimos tu información con terceros sin tu consentimiento.</li>
  </ul>
  <h2>Uso de la información</h2>
  <ul>
    <li>Utilizamos tus datos para mejorar la experiencia y la seguridad de la plataforma.</li>
    <li>Puedes solicitar la eliminación de tus datos en cualquier momento.</li>
  </ul>
  <h2>Contacto</h2>
  <p>Si tienes dudas sobre nuestra política de privacidad, escríbenos a <a href="mailto:soporte@innovadoc-ia.com">soporte&#64;innovadoc-ia.com</a>.</p>
</div>
